const BlockAccordion = {
  init: () => {
    const accordionBtns = BlockAccordion.getAllAccordionBtns();

    if (accordionBtns) {
      accordionBtns.forEach((btn) => {
        // close all accordions by default
        btn.setAttribute("aria-expanded", "false");

        btn.addEventListener("click", function (e) {
          e.preventDefault();
          BlockAccordion.handleAccordion(this);
        });
      });
    }
  },

  handleAccordion: (accordion) => {
    const expanded =
      accordion.getAttribute("aria-expanded") === "true" || false;
    accordion.setAttribute("aria-expanded", !expanded);
  },

  getAllAccordionBtns: () => {
    return Array.from(document.querySelectorAll(".digi-block-accordion__btn"));
  },
};

export default BlockAccordion;
